/* eslint no-param-reassign: 0 */

const defaultAccomodationsFilter = {
  freeSearch: '',
  beds: 1,
  bedrooms: 1,
  chargeStation: false,
  cleaning: false,
  date: {
    startDate: null,
    endDate: null,
  },
  dishwasher: false,
  fireplace: false,
  dryer_cabinet: false,
  washing_machine: false,
  pets: false,
  sauna: false,
  direct_incheck: false,
  internet: false,
  poolId: 0,
  locationId: 0,
  availabelIds: [],
  sorting: '',
  child_friendly: false,
};

export default defaultAccomodationsFilter;



// WEBPACK FOOTER //
// ./src/store-methods/defaultAccomodationsFilter.js